module.exports = __webpack_public_path__ + "img/certificate-1.2bb20463.png";